(() => {
  'use strict';

  /* ========================
     STATE
  ======================== */
  let bundleSize = 0;
  let selectedItems = [];
  let productCounts = {};
  let filledCount = 0;
  let isAdding = false;

  /* ========================
     HELPERS
  ======================== */
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => c.querySelectorAll(s);

  function formatMoney(cents) {
    const format = window.shopMoneyFormat || '{{amount}}';
    const value = (cents / 100).toFixed(2);

    return format
      .replace('{{amount_with_comma_separator}}', value)
      .replace('{{amount_no_decimals}}', Math.round(cents / 100))
      .replace('{{amount}}', value);
  }

  /* ========================
     DOM CACHE
  ======================== */
  const bundleBoxes = $$('.bundle-box');
  const slotsContainer = $('#bundle-slots');
  const modal = $('#color-modal');
  const modalBack = $('#modal-back');
  const modalGrid = $('.modal-grid');
  const progressFill = $('#progress-fill');
  const selectedCountEls = $$('#selected-count');
  const step2 = $('#step-2');
  const step2Title = $('#step2-title');
  const bundleLimit = $('#bundle-limit');

  /* ========================
     OPEN MODAL
  ======================== */
 document.addEventListener('click', (e) => {
  const btn = e.target.closest('#open-color-modal');

  if (btn) {
    modal?.classList.add('active');
  }
});

  modalBack?.addEventListener('click', () => {
    modal.classList.remove('active');
  });

  /* ========================
     BUNDLE SELECT
  ======================== */
  bundleBoxes.forEach(box => {
    box.addEventListener('click', () => {
      const size = parseInt(box.dataset.count, 10);

      if (!window.bundleConfig?.[size]) return;

      bundleBoxes.forEach(b => b.classList.remove('active'));
      box.classList.add('active');

      bundleSize = size;
      selectedItems = new Array(size).fill(null);
      productCounts = {};
      filledCount = 0;

      bundleLimit.innerText = size;
      step2.classList.remove('disabled');
      const template = step2Title.dataset.template;
      step2Title.innerText = template.replace("{count}", size);

      createSlots();
      updatePricing();
      updateUI();
    });
  });

  /* ========================
     AUTO SELECT DEFAULT
  ======================== */
  setTimeout(() => {
    const defaultBox = document.querySelector('.bundle-box[data-count="6"]');
    if (defaultBox) defaultBox.click();
  }, 150);

  /* ========================
     CREATE SLOTS
  ======================== */
  function createSlots() {
    slotsContainer.innerHTML = '';

    for (let i = 0; i < bundleSize; i++) {
      const div = document.createElement('div');
      div.className = 'bundle-slot';
      div.dataset.index = i;
      slotsContainer.appendChild(div);
    }
  }

  /* ========================
     PRICING
  ======================== */
  function updatePricing() {
  const config = window.bundleConfig?.[bundleSize];
  if (!config) return;

  const total = config.price;
  const compare = 29900 * bundleSize;
  const discount = Math.round(((compare - total) / compare) * 100);

  // Existing UI
  $('#bundle-total-price').innerHTML = formatMoney(total);
  $('#bundle-compare-price').innerHTML = formatMoney(compare);
  $('#bundle-discount').innerText = discount;

  // ✅ ADD THIS (BUTTON PRICE UPDATE)
  const currentEl = document.getElementById('btn-current-price');
  const compareEl = document.getElementById('btn-compare-price');

  if (currentEl) {
    currentEl.innerText = formatMoney(total);
  }

  if (compareEl) {
    compareEl.innerText = formatMoney(compare);
  }
}

  /* ========================
     SLOT CLICK
  ======================== */
  slotsContainer.addEventListener('click', (e) => {
    const slot = e.target.closest('.bundle-slot');
    if (!slot) return;

    const index = parseInt(slot.dataset.index);

    // REMOVE
    if (
      slot.classList.contains('filled') &&
      e.offsetX > slot.clientWidth - 30 &&
      e.offsetY < 30
    ) {
      const removedId = selectedItems[index];
      if (!removedId) return;

      selectedItems[index] = null;
      filledCount--;

      productCounts[removedId]--;

      const modalItem = document.querySelector(
        `.modal-color[data-variant-id="${removedId}"]`
      );

      if (modalItem) {
        const qtyEl = modalItem.querySelector('.qty');
        const qty = productCounts[removedId] || 0;

        if (qty <= 0) modalItem.classList.remove('active');
        qtyEl.innerText = qty;
      }

      slot.classList.remove('filled');
      slot.innerHTML = '';

      updateUI();
      return;
    }

    modal.classList.add('active');
  });

  /* ========================
     MODAL SELECT
  ======================== */
  modalGrid.addEventListener('click', (e) => {
  const card = e.target.closest('.modal-color');
  if (!card) return;

  // ✅ ADD THIS LINE (BLOCK OUT OF STOCK)
if (card.dataset.available !== "true") return;

  const id = card.dataset.variantId;
  const img = card.dataset.img;

  let qty = productCounts[id] || 0;
  const qtyEl = card.querySelector('.qty');

  const isAddBtn = e.target.classList.contains('add-btn');
  const isPlus = e.target.classList.contains('qty-plus');
  const isMinus = e.target.classList.contains('qty-minus');

  /* ========================
     AUTO ADD ON CARD CLICK
  ======================== */
  if (!isAddBtn && !isPlus && !isMinus) {
    if (filledCount >= bundleSize) return;

    qty++;
    productCounts[id] = qty;

    fillSlot(id, img);
    card.classList.add('active');

    qtyEl.innerText = qty;
    updateUI();
    return; // 🔥 important (stop double trigger)
  }

  /* ========================
     ADD BUTTON / PLUS
  ======================== */
  if (isAddBtn || isPlus) {
    if (filledCount >= bundleSize) return;

    qty++;
    productCounts[id] = qty;

    fillSlot(id, img);
    card.classList.add('active');
  }

  /* ========================
     MINUS
  ======================== */
  if (isMinus) {
    if (qty <= 0) return;

    qty--;
    productCounts[id] = qty;

    removeSlot(id);

    if (qty === 0) card.classList.remove('active');
  }

  qtyEl.innerText = qty;
  updateUI();
});

// ✅ Disable out of stock products
document.querySelectorAll('.modal-color').forEach(card => {
  const available = card.dataset.available === "true";

  if (!available) {
    card.classList.add('out-of-stock');
  }
});

  function fillSlot(id, img) {
    const slots = slotsContainer.children;

    for (let i = 0; i < bundleSize; i++) {
      if (!selectedItems[i]) {
        selectedItems[i] = id;
        filledCount++;

        const slot = slots[i];
        slot.classList.add('filled');
        slot.innerHTML = `<img src="${img}">`;
        return;
      }
    }
  }

  function removeSlot(id) {
    const slots = slotsContainer.children;

    for (let i = bundleSize - 1; i >= 0; i--) {
      if (selectedItems[i] === id) {
        selectedItems[i] = null;
        filledCount--;

        const slot = slots[i];
        slot.classList.remove('filled');
        slot.innerHTML = '';
        return;
      }
    }
  }

  /* ========================
     UI UPDATE
  ======================== */
  function updateUI() {
    selectedCountEls.forEach(el => (el.innerText = filledCount));

    const percent = bundleSize ? (filledCount / bundleSize) * 100 : 0;
    progressFill.style.width = percent + '%';

    const config = window.bundleConfig?.[bundleSize];
    const isComplete = !!config && filledCount === bundleSize;

    const modalBtn = document.getElementById('modal-add-cart');

    if (modalBtn) {
      modalBtn.disabled = !isComplete;
      modalBtn.innerText = isComplete
        ? "Add to Cart"
        : `Velge ${bundleSize - filledCount}`;
    }


    
  }

  /* ========================
     ADD TO CART (MODAL ONLY)
  ======================== */
  async function handleModalCart() {

  if (isAdding) return;

  const btn = document.getElementById('modal-add-cart');

  try {

    const config = window.bundleConfig?.[bundleSize];

    if (!config || filledCount !== bundleSize) {
      return;
    }

    isAdding = true;

    if (btn) {
      btn.disabled = true;
      btn.innerText = "Adding...";
    }

    /* ========================
       SINGLE BUNDLE ID
    ======================== */
    const bundleId = Date.now().toString();

    /* ========================
       GROUP SELECTED ITEMS
    ======================== */
    const grouped = {};

    selectedItems.forEach(id => {

      if (!id) return;

      grouped[id] = (grouped[id] || 0) + 1;

    });

    /* ========================
       BUILD CART ITEMS
    ======================== */
    const items = [];

    /* ========================
       CHILD PRODUCTS
    ======================== */
    Object.keys(grouped).forEach(vId => {

      items.push({
        id: Number(vId),
        quantity: grouped[vId],

        properties: {
          _bundle: "true",
          _bundle_id: bundleId,
          _bundle_size: bundleSize
        }

      });

    });

    /* ========================
       BUNDLE PARENT PRODUCT
    ======================== */
    items.push({

      id: Number(config.variantId),
      quantity: 1,

      properties: {
        _bundle_parent: "true",
        _bundle_id: bundleId,
        _bundle_size: bundleSize
      }

    });

    /* ========================
       ADD TO CART
    ======================== */
    const response = await fetch('/cart/add.js', {

      method: 'POST',

      headers: {
        'Content-Type': 'application/json'
      },

      body: JSON.stringify({
        items: items
      })

    });

    const data = await response.json();

    if (!response.ok || data.status) {
      throw new Error(data.description || 'Cart error');
    }

    /* ========================
       SUCCESS
    ======================== */
    if (btn) {
      btn.innerText = "Added ✓";
    }

    /* ========================
   SUCCESS
======================== */
if (response.ok && !data.status) {

  if (btn) {
    btn.innerText = "Added ✓";
  }

  /*
  =========================
  RUN AFTER ADD TO CART
  =========================
  */
  setTimeout(() => {

    /*
    CLOSE MODAL
    */
    modal?.classList.remove('active');

    /*
    OPEN CART DRAWER
    */
    if (window.upcartOpenCart) {
      window.upcartOpenCart();
    }

  }, 300);

}

  } catch (error) {

    console.error('Bundle cart error:', error);

    if (btn) {
      btn.disabled = false;
      btn.innerText = "Try Again";
    }

  } finally {

    isAdding = false;

  }

}


  /* ========================
     MODAL BUTTON CLICK
  ======================== */
  document.addEventListener('click', (e) => {
    if (e.target.id === 'modal-add-cart') {
      handleModalCart();
    }
  });


  /* ========================
   PRODUCT SLIDER
======================== */
function initProductSlider() {
  const sliders = document.querySelectorAll('.product-slider');

  sliders.forEach((slider) => {
    const main = slider.querySelector('.slider-main');
    const thumbs = slider.querySelectorAll('.thumb');
    const images = slider.querySelectorAll('.slider-image');

    if (!main || !images.length) return;

    let currentIndex = 0;
    let startX = 0;
    let isDragging = false;

    // 👉 THUMB CLICK
    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        updateSlider(parseInt(thumb.dataset.index));
      });
    });

    // 👉 TOUCH (mobile)
    main.addEventListener('touchstart', (e) => {
      startX = e.touches[0].clientX;
    }, { passive: true });

    main.addEventListener('touchend', (e) => {
      handleSwipe(e.changedTouches[0].clientX);
    });

    // 👉 DESKTOP DRAG (REAL FIX)
    main.addEventListener('mousedown', (e) => {
      isDragging = true;
      startX = e.clientX;
    });

    window.addEventListener('mouseup', (e) => {
      if (!isDragging) return;
      isDragging = false;
      handleSwipe(e.clientX);
    });

    // 👉 OPTIONAL: track movement (better accuracy)
    main.addEventListener('mousemove', (e) => {
      if (!isDragging) return;
      e.preventDefault(); // prevent image drag
    });

    function handleSwipe(endX) {
      const diff = startX - endX;

      if (Math.abs(diff) < 50) return;

      if (diff > 0) {
        goNext();
      } else {
        goPrev();
      }
    }

    function goNext() {
      if (currentIndex < images.length - 1) {
        updateSlider(currentIndex + 1);
      }
    }

    function goPrev() {
      if (currentIndex > 0) {
        updateSlider(currentIndex - 1);
      }
    }

    function updateSlider(index) {
      currentIndex = index;

      images.forEach((img) => img.classList.remove('active'));
      thumbs.forEach((t) => t.classList.remove('active'));

      if (images[index]) images[index].classList.add('active');
      if (thumbs[index]) thumbs[index].classList.add('active');
    }
  });
}


  // Run on page load
document.addEventListener('DOMContentLoaded', initProductSlider);

// Shopify editor support
document.addEventListener('shopify:section:load', initProductSlider);

})();